import { Box, Typography } from '@mui/material'

export default function DialogHeader(props) {
  return (
    <Box mt={1} mb={2} {...props}>
      <Typography variant="h7" noWrap> {props.children} </Typography>
    </Box>
  )
}